import React from 'react';
import {Container, Grid} from 'semantic-ui-react';
import CoverageDetails from "./coverageDetails";
import Footer from "./footer";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";
import moment from "moment";
import {usePreventBackNavigation} from "../hooks";
import {S3Image} from "./custom-common";
import IMAGE from "../constants/images"
const mapStateToProps = ({initialData}, ownProps) => {
    const strings = getLocalization(initialData.user.lang);

    const effectiveDate = moment(initialData.certificate.effectiveDate, "YYYY-MM-DD")
        .format("MMM DD, YYYY");

    return {
        ...ownProps,
        effectiveDate,
        strings,
    }
};

const SuccessfulPayment = ({effectiveDate, strings}) => {
    usePreventBackNavigation();

    return (
        <>
            <Container className={'stopScreens'}>
                <h1 className={'blueHeader'} style={{fontSize: '32px', marginBottom: '5px'}}>
                    {strings.paymentSuccessful.youAreAllSet}
                </h1>
                <p className={'neutral700Text noWrapText'}>
                    {strings.paymentSuccessful.yourBrellaCoverage}
                </p>
                <Grid style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{margin: '15px 0px'}}>
                        <p className={'neutral600Text'} style={{marginBottom: 0}}><b>
                            {strings.paymentSuccessful.coverageEffectiveDate}:
                        </b></p>
                        <h4 className={'neutral900Text'} style={{marginTop: '0'}}><b>{effectiveDate}</b></h4>
                    </div>
                    <S3Image {...IMAGE.PAYMENT_SUCCESS}/>
                </Grid>
                <CoverageDetails showReachOut={true} />
            </Container>
            <Footer />
        </>
    );
}

export default withRouter(connect(mapStateToProps)(SuccessfulPayment));
